// Порт ref BadgeEditor.tsx:90-271 — шапка «Бейджи (N/9)» + «Добавить» (пропадает
// на девятом) + строки. Ключ — собственный id бейджа (он стабилен и переживает
// удаление из середины), поэтому useStableKeys тут не нужен.
import { Plus } from 'lucide-react'
import { Button, Label } from '@teach/ui'
import type { DesignBadgeItem } from '@/types/blocks'
import { badgeItems, DESIGN_LIMITS, newBadgeItem } from '@/features/editor/lib/designElements'
import { useContentLang } from '@/features/editor/hooks/useContentLang'
import { getLocalizedField, setLocalizedField } from '@/features/editor/lib/localizedField'
import { BadgeRow } from './BadgeRow'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  badges: DesignBadgeItem[]
  onChange: (badges: DesignBadgeItem[]) => void
}

export const BadgeList = ({ badges, onChange }: Props) => {
  const m = useMessages(messages)
  const lang = useContentLang()
  // Списка может не быть вовсе (битые данные бека) — иначе TypeError уносил
  // не форму бейджа, а всю правую панель.
  const items = badgeItems(badges)
  const canAdd = items.length < DESIGN_LIMITS.BADGES

  // Патчим бейдж по id: остальные объекты (вместе с листом второго языка)
  // переезжают ссылкой, поэтому правка/удаление одного не задевает соседей.
  const patchAt = (id: string, patch: Partial<DesignBadgeItem>) =>
    onChange(items.map((b) => (b.id === id ? { ...b, ...patch } : b)))

  const addBadge = () => {
    if (!canAdd) return
    onChange([...items, newBadgeItem('')])
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-xs text-muted-foreground">
          {m.badgesCount(items.length, DESIGN_LIMITS.BADGES)}
        </Label>
        {canAdd ? (
          <Button variant="ghost" size="sm" onClick={addBadge} className="h-6 px-2 text-xs">
            <Plus className="mr-1 h-3 w-3" />
            {m.add}
          </Button>
        ) : null}
      </div>

      <div className="space-y-2">
        {items.map((badge) => (
          <BadgeRow
            key={badge.id}
            badge={badge}
            text={getLocalizedField(badge, 'text', lang) ?? ''}
            canRemove={items.length > 1}
            onChange={(patch) => patchAt(badge.id, patch)}
            onTextChange={(text) => patchAt(badge.id, setLocalizedField('text', lang, text))}
            onRemove={() => onChange(items.filter((b) => b.id !== badge.id))}
          />
        ))}
      </div>
    </div>
  )
}
